// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fMMr","col":"styles_col__3GgQF"};